import React from 'react';
import Link from '@/providers/Link';
import { urlPacotes } from '@/config/url';
import { NavElement, NavList, NavListItem } from './TravelTypeMenu.styles';
import { usePacotesListContext } from '@/features/pacote/PacotesList/context';
import { Title } from '@/components/typography';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import TravelTypeIcon from '@/features/pacote/PacotesList/components/TravelTypeIcon/TravelTypeIcon';
import { useTranslations } from 'next-intl';

const TravelTypeMenu = () => {
  const t = useTranslations('TravelTypeMenu');
  const {
    data: { destino, travelTypes, queryTravelType },
  } = usePacotesListContext();
  const items: [PacoteTravelType] | null = travelTypes;
  if (!items) return null;

  return (
    <WhitePaper>
      <Title as="h3" textCase="uppercase" color="secondary_500" size="lg">
        {t('Tipos de Viagem')}{' '}
        <span>
          {t('para o destino')} {destino.title}
        </span>
      </Title>
      <NavElement>
        <NavList>
          <NavListItem active={!queryTravelType}>
            <Link href={urlPacotes(`${destino.slug}`)}>
              <TravelTypeIcon width={32} />
              {t('Todos')}
            </Link>
          </NavListItem>
          {items.map(({ id, label, slug }) => (
            <NavListItem key={id} active={queryTravelType === id}>
              <Link href={urlPacotes(`${destino.slug}?travelType=${slug}`)}>
                <TravelTypeIcon id={id} width={32} />
                {label}
              </Link>
            </NavListItem>
          ))}
        </NavList>
      </NavElement>
    </WhitePaper>
  );
};

export default TravelTypeMenu;
